// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Receipt-container-DsQyd {
	width: 100%;
	max-width: 1080px;
	margin: 0 auto;
}

.Receipt-specialPriceIcon-HA9gR {
	display: inline-block;
	position: relative;
}

.Receipt-specialPriceIcon-HA9gR:hover .Receipt-toolTip-tQI3U {
	display: block;
}

.Receipt-faqImage-iGuq8 {
	width: 100%;
	max-width: 19px;
	vertical-align: middle;
	margin-right: 5px;
	position: relative;
	top: -2px;
}

.Receipt-toolTip-tQI3U {
	position: absolute;
	top: -48px;
	right: 0;
	left: 0px;
	display: none;
	background: var(--common-background-color);
	min-width: 280px;
	text-align: center;
	padding: 10px;
	border-radius: 6px;
	color: var(--white-text);
}

.Receipt-toolTipRelativeSection-EqbeQ::after {
	content: '';
	height: 100%;
	width: 100%;
	position: absolute;
	left: 10px;
	right: 0;
	top: 34px;
	bottom: 0;
	text-align: center;
	background-color: var(--common-background-color);
	z-index: 1;
	max-width: 11px;
	max-height: 11px;
	-webkit-transform: rotate(136deg);
	    -ms-transform: rotate(136deg);
	        transform: rotate(136deg);
}

.Receipt-diplayFlex-ChBjg {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.Receipt-mainSection-YHK5I {
	border: 1px solid var(--primary-border);
	border-radius: 12px;
	padding: 24px;
}

.Receipt-displayGridDate-erERy {
	display: grid;
	grid-template-columns: 40% 10% 50%;
	-webkit-box-align: start;
	    -ms-flex-align: start;
	        align-items: flex-start;
}

.Receipt-displayGridDetails-UNWr8 {
	display: grid;
	grid-template-columns: 50% 50%;
}

.Receipt-mainGrid-NJNdL {
	display: grid;
	grid-template-columns: 640px auto;
}

.Receipt-bgColor-KhmTe {
	background-color: var(--common-gray-bg-color);
}

.Receipt-flexBillingSection-fbFrO {
	-ms-flex-wrap: nowrap;
	    flex-wrap: nowrap;
	-webkit-box-align: baseline;
	    -ms-flex-align: baseline;
	        align-items: baseline;
}

.Receipt-infoGrid-MMCMP {
	display: grid;
	grid-template-columns: auto auto;
	-webkit-box-pack: start;
	    -ms-flex-pack: start;
	        justify-content: flex-start;
}

.Receipt-infoDetailsPadding-b7sdg {
	padding: 0px 4px 0 0;
}

/* 
.tripArrowIconSec{
	position: relative;
	top: -9px;
} */

.Receipt-carNameLink-g7nnV {
	display: inline-block;
	cursor: pointer;
}

.Receipt-splitUpColOneWidth-NGBVQ {
	width: 60%;
}

.Receipt-splitUpColTwoWidth-xmqOD {
	width: 38%;
}

.Receipt-displayInline-e5x_9 {
	display: inline-block;
}

.Receipt-colSpaceRight-T83Dg {
	padding-right: 15px;
}

.Receipt-directionRTLPrint-sAo9_ {
	direction: rtl;
}

.Receipt-receiptGrid-P4Q16 {
	display: grid;
	grid-template-columns: 56% 41%;
	gap: 30px;
	position: relative;
}

.Receipt-discountColor-MPkZy,
.Receipt-discountColor-MPkZy:hover,
.Receipt-discountColor-MPkZy:focus {
	color: #3fb34f;
}

.Receipt-paddingRight-ubVQj {
	padding-right: 10px;
}

.Receipt-positionStickey-o_zpt {
	position: sticky;
	top: 30px;
	height: -webkit-max-content;
	height: -moz-max-content;
	height: max-content
}

@media (max-width: 1024px) and (min-width: 768px) {
	.Receipt-receiptGrid-P4Q16 {
		grid-template-columns: 56% 40%;
	}
}

@media screen and (max-width: 991px) {
	.Receipt-mainGrid-NJNdL {
		display: grid;
		grid-template-columns: 100%;
	}
}

@media screen and (max-width: 767px) {
	.Receipt-toolTip-tQI3U {
		top: 29px;
		right: 0;
		min-width: 250px;
	}

	.Receipt-toolTipRelativeSection-EqbeQ::after {
		top: -3px;
	}

	.Receipt-displayGridDate-erERy {
		grid-template-columns: 42% 16% 42%;
	}

	.Receipt-fullWidthMobile-rz1DL {
		width: 100%;
	}

	.Receipt-displayGridDetails-UNWr8 {
		grid-template-columns: 100%;
	}

	.Receipt-colSpaceRight-T83Dg {
		padding-right: 0;
	}

	.Receipt-receiptGrid-P4Q16 {
		grid-template-columns: 100%;
	}

	.Receipt-positionStickey-o_zpt {
		height: auto;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Receipt/Receipt.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;CACtB,iBAAiB;CACjB,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,SAAS;CACT,aAAa;CACb,0CAA0C;CAC1C,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;CACb,kBAAkB;CAClB,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,SAAS;CACT,SAAS;CACT,kBAAkB;CAClB,gDAAgD;CAChD,UAAU;CACV,eAAe;CACf,gBAAgB;CAChB,iCAAyB;KAAzB,6BAAyB;SAAzB,yBAAyB;AAC1B;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,uCAAuC;CACvC,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,aAAa;CACb,kCAAkC;CAClC,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,iCAAiC;AAClC;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;CACC,qBAAiB;KAAjB,iBAAiB;CACjB,2BAAqB;KAArB,wBAAqB;SAArB,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,gCAAgC;CAChC,uBAA2B;KAA3B,oBAA2B;SAA3B,2BAA2B;AAC5B;;AAEA;CACC,oBAAoB;AACrB;;AAEA;;;;GAIG;;AAEH;CACC,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,SAAS;CACT,kBAAkB;AACnB;;AAEA;;;CAGC,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,2BAAkB;CAAlB,wBAAkB;CAAlB;AACD;;AAEA;CACC;EACC,8BAA8B;CAC/B;AACD;;AAEA;CACC;EACC,aAAa;EACb,2BAA2B;CAC5B;AACD;;AAEA;CACC;EACC,SAAS;EACT,QAAQ;EACR,gBAAgB;CACjB;;CAEA;EACC,SAAS;CACV;;CAEA;EACC,kCAAkC;CACnC;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,YAAY;CACb;AACD","sourcesContent":[".container {\n\twidth: 100%;\n\tmax-width: 1080px;\n\tmargin: 0 auto;\n}\n\n.specialPriceIcon {\n\tdisplay: inline-block;\n\tposition: relative;\n}\n\n.specialPriceIcon:hover .toolTip {\n\tdisplay: block;\n}\n\n.faqImage {\n\twidth: 100%;\n\tmax-width: 19px;\n\tvertical-align: middle;\n\tmargin-right: 5px;\n\tposition: relative;\n\ttop: -2px;\n}\n\n.toolTip {\n\tposition: absolute;\n\ttop: -48px;\n\tright: 0;\n\tleft: 0px;\n\tdisplay: none;\n\tbackground: var(--common-background-color);\n\tmin-width: 280px;\n\ttext-align: center;\n\tpadding: 10px;\n\tborder-radius: 6px;\n\tcolor: var(--white-text);\n}\n\n.toolTipRelativeSection::after {\n\tcontent: '';\n\theight: 100%;\n\twidth: 100%;\n\tposition: absolute;\n\tleft: 10px;\n\tright: 0;\n\ttop: 34px;\n\tbottom: 0;\n\ttext-align: center;\n\tbackground-color: var(--common-background-color);\n\tz-index: 1;\n\tmax-width: 11px;\n\tmax-height: 11px;\n\ttransform: rotate(136deg);\n}\n\n.diplayFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tflex-wrap: wrap;\n}\n\n.mainSection {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n\tpadding: 24px;\n}\n\n.displayGridDate {\n\tdisplay: grid;\n\tgrid-template-columns: 40% 10% 50%;\n\talign-items: flex-start;\n}\n\n.displayGridDetails {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n}\n\n.mainGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 640px auto;\n}\n\n.bgColor {\n\tbackground-color: var(--common-gray-bg-color);\n}\n\n.flexBillingSection {\n\tflex-wrap: nowrap;\n\talign-items: baseline;\n}\n\n.infoGrid {\n\tdisplay: grid;\n\tgrid-template-columns: auto auto;\n\tjustify-content: flex-start;\n}\n\n.infoDetailsPadding {\n\tpadding: 0px 4px 0 0;\n}\n\n/* \n.tripArrowIconSec{\n\tposition: relative;\n\ttop: -9px;\n} */\n\n.carNameLink {\n\tdisplay: inline-block;\n\tcursor: pointer;\n}\n\n.splitUpColOneWidth {\n\twidth: 60%;\n}\n\n.splitUpColTwoWidth {\n\twidth: 38%;\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n.colSpaceRight {\n\tpadding-right: 15px;\n}\n\n.directionRTLPrint {\n\tdirection: rtl;\n}\n\n.receiptGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 56% 41%;\n\tgap: 30px;\n\tposition: relative;\n}\n\n.discountColor,\n.discountColor:hover,\n.discountColor:focus {\n\tcolor: #3fb34f;\n}\n\n.paddingRight {\n\tpadding-right: 10px;\n}\n\n.positionStickey {\n\tposition: sticky;\n\ttop: 30px;\n\theight: max-content\n}\n\n@media (max-width: 1024px) and (min-width: 768px) {\n\t.receiptGrid {\n\t\tgrid-template-columns: 56% 40%;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.mainGrid {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 100%;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.toolTip {\n\t\ttop: 29px;\n\t\tright: 0;\n\t\tmin-width: 250px;\n\t}\n\n\t.toolTipRelativeSection::after {\n\t\ttop: -3px;\n\t}\n\n\t.displayGridDate {\n\t\tgrid-template-columns: 42% 16% 42%;\n\t}\n\n\t.fullWidthMobile {\n\t\twidth: 100%;\n\t}\n\n\t.displayGridDetails {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.colSpaceRight {\n\t\tpadding-right: 0;\n\t}\n\n\t.receiptGrid {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.positionStickey {\n\t\theight: auto;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Receipt-container-DsQyd`,
	"specialPriceIcon": `Receipt-specialPriceIcon-HA9gR`,
	"toolTip": `Receipt-toolTip-tQI3U`,
	"faqImage": `Receipt-faqImage-iGuq8`,
	"toolTipRelativeSection": `Receipt-toolTipRelativeSection-EqbeQ`,
	"diplayFlex": `Receipt-diplayFlex-ChBjg`,
	"mainSection": `Receipt-mainSection-YHK5I`,
	"displayGridDate": `Receipt-displayGridDate-erERy`,
	"displayGridDetails": `Receipt-displayGridDetails-UNWr8`,
	"mainGrid": `Receipt-mainGrid-NJNdL`,
	"bgColor": `Receipt-bgColor-KhmTe`,
	"flexBillingSection": `Receipt-flexBillingSection-fbFrO`,
	"infoGrid": `Receipt-infoGrid-MMCMP`,
	"infoDetailsPadding": `Receipt-infoDetailsPadding-b7sdg`,
	"carNameLink": `Receipt-carNameLink-g7nnV`,
	"splitUpColOneWidth": `Receipt-splitUpColOneWidth-NGBVQ`,
	"splitUpColTwoWidth": `Receipt-splitUpColTwoWidth-xmqOD`,
	"displayInline": `Receipt-displayInline-e5x_9`,
	"colSpaceRight": `Receipt-colSpaceRight-T83Dg`,
	"directionRTLPrint": `Receipt-directionRTLPrint-sAo9_`,
	"receiptGrid": `Receipt-receiptGrid-P4Q16`,
	"discountColor": `Receipt-discountColor-MPkZy`,
	"paddingRight": `Receipt-paddingRight-ubVQj`,
	"positionStickey": `Receipt-positionStickey-o_zpt`,
	"fullWidthMobile": `Receipt-fullWidthMobile-rz1DL`
};
module.exports = ___CSS_LOADER_EXPORT___;
